import { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useInboxAlerts } from '@/features/alerts/use-inbox-alerts';
import { Header } from './Header';
import { Sidebar } from './Sidebar';

/**
 * Layout del panel autenticado: sidebar de 240px + header sticky + área de contenido.
 *
 * Área de contenido: fondo `canvas` gris azulado y una columna centrada con tope de ancho
 * (1600px) para que en pantallas grandes las tarjetas no se estiren sin sentido —
 * exactamente el comportamiento de la referencia visual.
 *
 * En móvil el sidebar se abre como drawer y se cierra solo al navegar.
 *
 * Los AVISOS de mensajes nuevos se montan aquí, no en Conversaciones, porque las DOS burbujas tienen
 * que verse desde cualquier pantalla: el hook lee la primera página de la bandeja cada
 * `INBOX_REFRESH_MS` y reparte el resultado entre el menú («Conversaciones») y el header (Mensajes).
 * El detalle de QUIÉN escribió se ve dentro de la propia bandeja (aviso + punto azul en la fila): aquí
 * NO hay aviso flotante, porque llegan mensajes todo el rato y tapaban la pantalla de trabajo.
 * El estado de «ya visto» es del navegador (`stores/inbox-alerts-store.ts`), así que abrir una
 * conversación apaga las burbujas y el punto a la vez.
 */
export function AppLayout() {
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const location = useLocation();
  const { alertas } = useInboxAlerts();

  useEffect(() => {
    setMobileNavOpen(false);
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-canvas">
      <a
        href="#contenido"
        className="sr-only focus:not-sr-only focus:absolute focus:top-3 focus:left-3 focus:z-[60] focus:rounded-control focus:bg-surface focus:px-3 focus:py-2 focus:text-body focus:text-ink focus:shadow-pop"
      >
        Saltar al contenido
      </a>

      <Sidebar
        mobileOpen={mobileNavOpen}
        onCloseMobile={() => setMobileNavOpen(false)}
        alertas={alertas}
      />

      <div className="lg:pl-60">
        <Header onOpenMobileNav={() => setMobileNavOpen(true)} alertas={alertas} />

        <main id="contenido" className="mx-auto w-full max-w-[1600px] px-4 py-6 sm:px-6 sm:py-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
